<template>
	<div
		class="box"
		:class="{ border: border, 'transparent-background': transparentBackground }"
	>
		<slot class="slot" />
	</div>
</template>

<script>
/**
 * Simple layout container.
 * By default has a thin border and a white background.
 */
export default {
	name: 'Box',
	props: {
		border: {
			type: Boolean,
			default: true,
		},
		transparentBackground: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.box {
	background: $white;
	border-radius: $b360-border-radius-base;
	@include rem(padding, 15px);

	&.border {
		border: $b360-border-width-thin solid $border-color-light;
	}

	&.transparent-background {
		background-color: transparent;
	}

	.slot {
		@include rem('margin', 10px);
	}
}
</style>
